/* ===== cc-search.js ===== */

/* cc-search.js
 * Carved Culture Search — all storefront JavaScript in one file.
 * Sections (in load order): settings, synonyms, cache, scoring, rendering,
 * search, analytics, ui. Regenerate from the Smart Search admin app after
 * changing settings.
 */

// settings.js
// Fallback default configuration for Carved Culture Smart Search.
// The storefront reads the live config from the shop metaobject
// (type "sidekick_smart_search_config", handle "default") injected by
// smart-search.liquid. These values are only used when that config is missing.
// Regenerate this file from the Smart Search admin app after changing settings.

window.SmartSearchDefaults = {
  "weights": {
    "exactTitleMatch": 1000,
    "startsWithQuery": 700,
    "titleContainsQuery": 500,
    "productTypeMatch": 300,
    "collectionMatch": 250,
    "tagMatch": 200,
    "synonymMatch": 250,
    "availabilityInStock": 150,
    "bestseller": 150,
    "manualBoostMultiplier": 1,
    "recencyWeight": 50,
    "conversionWeight": 100,
    "ctrWeight": 75,
    "ratingWeight": 50
  },
  "synonyms": [
    {
      "term": "thumb piano",
      "alternatives": [
        "kalimba",
        "mbira"
      ]
    },
    {
      "term": "book",
      "alternatives": [
        "ebook",
        "complete",
        "songbook"
      ]
    }
  ],
  "featured": [
  "Kalimba",
  "Kashaka",
  "Rainstick",
  "Gong",
  "Shamanic Drum",
  "Tambourine",
  "Singing Bowl",
  "Chimes",
  "Agogo",
  "Peruvian Flute"
],
  "boosts": [],
"featuredProducts": [
  "kashaka-cas-cas-shakers",
  "peruvian-bird-water-whistle-6cm",
  "siku-pan-pipes",
  "gobijeu-indian-stringed-instrument",
  "17-note-kalimba-bundle",
  "croaking-frog-guiro"
],
  "appearance": {
    "showSuggestions": true,
    "showPages": true,
    "showProducts": true,
    "maxProducts": 6,
    "maxSuggestions": 5,
    "background": "#FFFFFF",
    "text": "#1A1A1A",
    "button": "#000000",
    "accent": "#000000",
    "borderRadius": 12,
    "fontSize": 15,
    "atcBackground": "#1A1A1A",
    "atcText": "#FFFFFF",
    "barBorder": "#dcdcdc",
    "suggestionIcon": "#b0b0b0"
  }
};

// If the Liquid snippet injected a live config, prefer it; otherwise use defaults.
window.SmartSearchConfig = (window.SmartSearchLiveConfig && Object.keys(window.SmartSearchLiveConfig).length)
  ? window.SmartSearchLiveConfig
  : window.SmartSearchDefaults;


// synonyms.js
// Expands a query with any configured synonym alternatives before searching.
(function () {
  function config() {
    return window.SmartSearchConfig || window.SmartSearchDefaults || {};
  }

  // Returns an array of query strings to search: the original plus alternatives.
  function expandQuery(query) {
    var q = (query || '').trim().toLowerCase();
    var out = [q];
    var rules = (config().synonyms) || [];
    for (var i = 0; i < rules.length; i++) {
      var rule = rules[i];
      if (!rule || !rule.term) continue;
      if (q.indexOf(rule.term.toLowerCase()) !== -1) {
        var alts = rule.alternatives || [];
        for (var j = 0; j < alts.length; j++) {
          var alt = (alts[j] || '').trim();
          if (alt && out.indexOf(alt.toLowerCase()) === -1) out.push(alt.toLowerCase());
        }
      }
    }
    return out;
  }

  window.SmartSearchSynonyms = { expandQuery: expandQuery };
})();
// ── Levenshtein fuzzy match ──────────────────────────────────────────────────
var SmartSearchFuzzy = (function () {

  function levenshtein(a, b) {
    var m = a.length, n = b.length;
    var dp = [];
    for (var i = 0; i <= m; i++) {
      dp[i] = [i];
      for (var j = 1; j <= n; j++) {
        dp[i][j] = i === 0 ? j
          : j === 0 ? i
          : a[i - 1] === b[j - 1] ? dp[i - 1][j - 1]
          : 1 + Math.min(dp[i - 1][j], dp[i][j - 1], dp[i - 1][j - 1]);
      }
    }
    return dp[m][n];
  }

  // Known terms to match against — add your full product/category vocabulary here
  var KNOWN_TERMS = [
    'kalimba', 'kashaka', 'panpipes', 'ocarina', 'ocarinas', 'didgeridoo',
    'didgeridoos', 'rainstick', 'rainsticks', 'tongue drum', 'tongue drums',
    'singing bowl', 'singing bowls', 'djembe', 'djembes', 'shekere',
    'guiro', 'maracas', 'windchimes', 'xylophone', 'xylophones',
    'metallophone', 'metallophones', 'kazoo', 'kazoos', 'flute', 'flutes',
    'whistle', 'whistles', 'gong', 'gongs', 'drum', 'drums',
    'ocean drum', 'thunder drum', 'shamanic drum', 'indian drum',
    'seed shaker', 'shamanic shaker', 'shaker', 'shakers', 'clacker', 'clackers',
    'mallet', 'mallets', 'bell', 'bells'
  ];

  // Max edit distance allowed — 2 catches most real-world typos
  var MAX_DISTANCE = 2;

  function correct(query) {
    var q = query.toLowerCase().trim();
    var words = q.split(/\s+/);

    var corrected = words.map(function (word) {
      if (word.length <= 3) return word; // don't fuzz short words
      var best = word;
      var bestDist = MAX_DISTANCE + 1;
      for (var i = 0; i < KNOWN_TERMS.length; i++) {
        var term = KNOWN_TERMS[i];
        // Only compare single-word terms against single words
        if (term.indexOf(' ') !== -1) continue;
        var dist = levenshtein(word, term);
        if (dist < bestDist) {
          bestDist = dist;
          best = dist <= MAX_DISTANCE ? term : word;
        }
      }
      return best;
    });

    var correctedQuery = corrected.join(' ');

    // Also try matching the full multi-word query against multi-word known terms
    for (var i = 0; i < KNOWN_TERMS.length; i++) {
      var term = KNOWN_TERMS[i];
      if (term.indexOf(' ') === -1) continue;
      if (levenshtein(q, term) <= MAX_DISTANCE) {
        return term;
      }
    }

    return correctedQuery;
  }

  return { correct: correct };
})();

// cache.js
// Simple in-memory cache so repeated identical searches feel instant.
(function () {
  var store = {};
  function get(key) { return store[key]; }
  function set(key, value) { store[key] = value; }
  function has(key) { return Object.prototype.hasOwnProperty.call(store, key); }
  function clear() { store = {}; }

  // Recently searched terms persisted in localStorage (best-effort).
  function recent() {
    try { return JSON.parse(localStorage.getItem('ss_recent') || '[]'); }
    catch (e) { return []; }
  }
  function addRecent(term) {
    try {
      var list = recent().filter(function (t) { return t !== term; });
      list.unshift(term);
      localStorage.setItem('ss_recent', JSON.stringify(list.slice(0, 8)));
    } catch (e) {}
  }

  window.SmartSearchCache = { get: get, set: set, has: has, clear: clear, recent: recent, addRecent: addRecent };
})();
// bestseller.js
(function () {
  var ranks = {};

  function load() {
    fetch('/collections/all/products.json?sort_by=best-selling&limit=20')
      .then(function(r) { return r.json(); })
      .then(function(data) {
        var products = (data && data.products) || [];
        products.forEach(function(p, idx) {
          ranks[p.handle] = idx + 1;
        });
      })
      .catch(function() {});
  }

  function getRank(handle) {
    return ranks[handle] || null;
  }

  load();
  window.SmartSearchBestsellers = { getRank: getRank };
})();
// scoring.js
// Rescores raw predictive-search results using the configured weights.
(function () {
  function config() {
    return window.SmartSearchConfig || window.SmartSearchDefaults || {};
  }

  function levenshtein(a, b) {
    a = a || ''; b = b || '';
    var m = a.length, n = b.length;
    if (!m) return n;
    if (!n) return m;
    var prev = [], cur = [], i, j;
    for (j = 0; j <= n; j++) prev[j] = j;
    for (i = 1; i <= m; i++) {
      cur[0] = i;
      for (j = 1; j <= n; j++) {
        var cost = a.charAt(i - 1) === b.charAt(j - 1) ? 0 : 1;
        cur[j] = Math.min(prev[j] + 1, cur[j - 1] + 1, prev[j - 1] + cost);
      }
      for (j = 0; j <= n; j++) prev[j] = cur[j];
    }
    return prev[n];
  }

  function boostFor(term, product) {
    var rules = (config().boosts) || [];
    var mult = (config().weights && config().weights.manualBoostMultiplier) || 1;
    var total = 0;
    var cols = (product.collections || []).map(function (c) {
      return String((c && (c.handle || c.title)) || c).toLowerCase();
    });
    for (var i = 0; i < rules.length; i++) {
      var r = rules[i];
      if (!r || !r.term) continue;
      if (term.indexOf(r.term.toLowerCase()) === -1) continue;
      var target = (r.target || '').toLowerCase();
      if (r.targetType === 'product' && product.handle && target &&
          product.handle.toLowerCase() === target) {
        total += (Number(r.amount) || 0);
      } else if (r.targetType === 'collection' && target && cols.indexOf(target) !== -1) {
        total += (Number(r.amount) || 0);
      }
    }
    return total * mult;
  }

   function scoreProduct(query, product) {
    var w = config().weights || {};
    var q = (query || '').trim().toLowerCase();
    var title = (product.title || '').toLowerCase();
    var desc = (product.description || '').toLowerCase();
    var score = 0;

    var stopWords = ['how', 'to', 'the', 'a', 'an', 'and', 'or', 'for', 'of', 'in', 'is', 'it', 'do', 'i', 'my', 'what', 'best', 'play', 'learn', 'use', 'get'];
    var keywords = q.split(/\s+/).filter(function(kw) {
      return kw.length > 2 && stopWords.indexOf(kw) === -1;
    }).sort(function(a, b) { return b.length - a.length; });

    if (title === q) score += (w.exactTitleMatch || 0);
    else if (title.indexOf(q) === 0) score += (w.startsWithQuery || 0);
    else if (title.indexOf(q) !== -1) score += (w.titleContainsQuery || 0);

    keywords.forEach(function(kw, idx) {
      var weight = 1 / (idx + 1);
      if (title === kw) score += (w.exactTitleMatch || 0) * weight;
      else if (title.indexOf(kw) === 0) score += (w.startsWithQuery || 0) * weight;
      else if (title.indexOf(kw) !== -1) score += (w.titleContainsQuery || 0) * weight;
      else {
        var firstWord = title.split(' ')[0] || '';
        if (kw.length > 2 && levenshtein(kw, firstWord) <= 2) {
          score += Math.round((w.titleContainsQuery || 0) * 0.4) * weight;
        }
      }
      if (desc && desc.indexOf(kw) !== -1) {
        score += Math.round((w.titleContainsQuery || 0) * 0.3) * weight;
      }
    });

    if (product.product_type && product.product_type.toLowerCase().indexOf(q) !== -1) {
      score += (w.productTypeMatch || 0);
    }

    var cols = product.collections || [];
    for (var c = 0; c < cols.length; c++) {
      var cName = String((cols[c] && (cols[c].title || cols[c].handle)) || cols[c]).toLowerCase();
      if (cName.indexOf(q) !== -1) { score += (w.collectionMatch || 0); break; }
    }

    if (product.tags) {
      var tags = Array.isArray(product.tags) ? product.tags : String(product.tags).split(',');
      for (var t = 0; t < tags.length; t++) {
        var tag = String(tags[t]).toLowerCase().trim();
        if (keywords.some(function(kw) { return tag.indexOf(kw) !== -1; })) {
          score += (w.tagMatch || 0); break;
        }
      }
    }

    if (product.matchedViaSynonym) score += (w.synonymMatch || 0);
    if (product.available) score += (w.availabilityInStock || 0);

    var bsRank = window.SmartSearchBestsellers ? window.SmartSearchBestsellers.getRank(product.handle) : null;
    var salesRank = typeof product.sales_rank === 'number' ? product.sales_rank : bsRank;
    if (typeof salesRank === 'number') {
      score += Math.max(0, (w.bestseller || 0) - salesRank);
    }

    if (product.created_at) {
      var ageDays = (Date.now() - new Date(product.created_at).getTime()) / 86400000;
      if (isFinite(ageDays) && ageDays >= 0 && ageDays <= 30) {
        score += Math.round((w.recencyWeight || 0) * (1 - ageDays / 30));
      }
    }
    if (typeof product.conversion_rate === 'number') score += product.conversion_rate * (w.conversionWeight || 0);
    if (typeof product.ctr === 'number') score += product.ctr * (w.ctrWeight || 0);
    if (typeof product.rating === 'number') score += product.rating * (w.ratingWeight || 0) / 5;

    score += boostFor(q, product);
    return score;
  }

  function rankProducts(query, products) {
    var q = (query || '').trim().toLowerCase();
    return (products || [])
      .map(function (p) { return { product: p, score: scoreProduct(q, p) }; })
      .sort(function (a, b) {
        if (!!a.product.available !== !!b.product.available) {
          return a.product.available ? -1 : 1;
        }
        return b.score - a.score;
      })
      .map(function (x) { return x.product; });
  }

  window.SmartSearchScoring = { scoreProduct: scoreProduct, rankProducts: rankProducts, levenshtein: levenshtein };
})();

// rendering.js
// Builds the two-column dropdown markup from ranked results.
(function () {
  function config() {
    return window.SmartSearchConfig || window.SmartSearchDefaults || {};
  }

  function stripHtml(html) {
    var tmp = document.createElement('div');
    tmp.innerHTML = html || '';
    return (tmp.textContent || tmp.innerText || '').replace(/\s+/g, ' ').trim();
  }

  function truncate(str, n) {
    str = str || '';
    return str.length > n ? str.slice(0, n).trim() + '…' : str;
  }

  // The predictive search API returns prices as decimal strings ("30.00") or
  // occasionally as numbers. Do NOT divide by 100.
function formatMoney(raw) {
  var shop = window.SmartSearchShop || {};
  var currency = shop.currency;
  var rate = typeof shop.fxRate === 'number' && shop.fxRate > 0 ? shop.fxRate : 1;
  if (!raw && raw !== 0) return '';
  var n = typeof raw === 'string' ? parseFloat(raw) : Number(raw);
  if (!isFinite(n)) return '';
  n = n * rate;
  // If currency is null, derive symbol from moneyFormat e.g. "${{amount}}"
  if (!currency) {
    var fmt = shop.moneyFormat || '{{amount}}';
    var symbol = fmt.replace(/\{\{.*?\}\}/g, '').trim() || '£';
    return symbol + n.toFixed(2);
  }
  try {
    return new Intl.NumberFormat('en-US', { style: 'currency', currency: currency }).format(n);
  } catch (e) {
    return currency + ' ' + n.toFixed(2);
  }
}


  function boldMatch(text, query) {
    if (!query) return text;
    var idx = text.toLowerCase().indexOf(query.toLowerCase());
    if (idx === -1) return text;
    return text.slice(0, idx) + '<strong>' + text.slice(idx, idx + query.length) + '</strong>' + text.slice(idx + query.length);
  }

  function searchHref(label) {
    return (window.SmartSearchShop && window.SmartSearchShop.searchUrl || '/search') + '?q=' + encodeURIComponent(label);
  }

  // A suggestion row with a leading magnifying-glass icon and bolded match.
  function suggestionItem(label, query, href) {
    return '<li class="ss-suggestion" role="option">' +
      '<a href="' + href + '"><span class="ss-suggestion__icon" aria-hidden="true">⌕</span>' +
      '<span class="ss-suggestion__label">' + boldMatch(label, query) + '</span></a></li>';
  }

  // A page/article row with a leading circle-i icon and bolded match.
  function pageItem(title, query, href) {
    return '<li class="ss-suggestion ss-page" role="option">' +
      '<a href="' + href + '"><span class="ss-suggestion__icon" aria-hidden="true">ⓘ</span>' +
      '<span class="ss-suggestion__label">' + boldMatch(title, query) + '</span></a></li>';
  }

  function productCard(p) {
    var price = formatMoney(p.price);
    var compare = p.compare_at_price ? formatMoney(p.compare_at_price) : '';
    var onSale = compare && compare !== price;
    var desc = truncate(stripHtml(p.description || p.body || ''), 80);
    return '<div class="ss-card">' +
      '<a class="ss-card__media" href="' + (p.url || '#') + '">' +
      (p.image ? '<img class="ss-card__img" src="' + p.image + '" alt="" loading="lazy">' : '<span class="ss-card__img ss-card__img--empty"></span>') +
      '</a>' +
      '<div class="ss-card__body">' +
      '<a class="ss-card__title" href="' + (p.url || '#') + '">' + (p.title || '') + '</a>' +
      (desc ? '<div class="ss-card__desc">' + desc + '</div>' : '') +
      '<div class="ss-card__price">' +
        (onSale ? '<span class="ss-card__sale-badge">Sale</span>' : '') +
        '<span class="ss-card__now">' + price + '</span>' +
        (onSale ? '<span class="ss-card__was">' + compare + '</span>' : '') +
      '</div>' +
      '<button class="ss-card__atc" data-variant="' + (p.variant_id || '') + '" data-handle="' + (p.handle || '') + '"' +
        (p.available ? '' : ' disabled') + '>' +
        (p.available ? 'Add to cart' : 'Sold out') + '</button>' +
      '</div></div>';
  }

  function render(panel, query, data) {
    var appearance = config().appearance || {};
    var isMobile = window.innerWidth <= 999;
    var allPages = data.pages || [];
    var left = '';
    var right = '';

    if (isMobile) {
      var mobileProducts = (data.products || []).slice(0, 2);
      var mobilePages = allPages.filter(function(pg) { return pg.kind === 'page'; }).slice(0, 2);
      var mobileArticles = allPages.filter(function(pg) { return pg.kind === 'article'; }).slice(0, 1);
      var mobileList = '';
       mobileProducts.forEach(function(p) {
        var img = p.image ? '<img src="' + p.image + '" alt="' + p.title + '" style="width:36px;height:36px;object-fit:cover;border-radius:4px;flex-shrink:0;">' : '';
        mobileList += '<li role="option" style="list-style:none;"><a href="' + p.url + '" style="display:flex;align-items:center;gap:10px;padding:10px 0;text-decoration:none;color:#1a1a1a;border-bottom:1px solid #f5f5f5;">' +
          img +
          '<span style="font-size:15px;">' + p.title + '</span></a></li>';
      });
            mobilePages.concat(mobileArticles).forEach(function(pg) {
        mobileList += pageItem(pg.title, query, pg.url);
      });
      if (mobileList) {
        left += '<div class="ss-col__section"><h3 class="ss-col__title">Suggested</h3><ul class="ss-list">' +
          mobileList + '</ul></div>';
      }
      var total = (data.totalProducts || (data.products || []).length);
      left += '<a class="ss-viewall" href="' + searchHref(query) + '">VIEW ALL ' + total + ' ITEMS →</a>';
    } else {
      var maxProducts = appearance.maxProducts || 6;
      var products = (data.products || []).slice(0, maxProducts);
      var maxPages = 5;
      var pages = allPages.slice(0, maxPages);
      if (appearance.showPages !== false && pages.length) {
        left += '<div class="ss-col__section"><h3 class="ss-col__title">Suggested</h3><ul class="ss-list">' +
          pages.map(function(pg) { return pageItem(pg.title, query, pg.url); }).join('') + '</ul>' +
          (allPages.length > maxPages ? '<a class="ss-more" href="' + searchHref(query) + '">More →</a>' : '') +
          '</div>';
      }
      var total = (data.totalProducts || products.length);
      left += '<a class="ss-viewall" href="' + searchHref(query) + '">VIEW ALL ' + total + ' ITEMS →</a>';
      if (appearance.showProducts !== false) {
        right = '<h3 class="ss-col__title">Products</h3><div class="ss-grid">' +
          (products.length ? products.map(productCard).join('') : '<div class="ss-empty">No products found</div>') +
          '</div>';
      }
    }

    panel.innerHTML = '<div class="ss-columns"><div class="ss-col ss-col--left">' + left +
      '</div><div class="ss-col ss-col--right">' + right + '</div></div>';
  }

  function renderEmpty(panel, featured) {
  var list = (featured && featured.length) ? featured : ['Kalimba', 'Kashaka', 'Rainstick', 'Singing Bowl'];
    var left = '<div class="ss-col__section"><h3 class="ss-col__title">Suggested</h3><ul class="ss-list">' +
      list.slice(0, 5).map(function (t) { return suggestionItem(t, '', searchHref(t)); }).join('') +
      '</ul></div>' +
      '<a class="ss-viewall" href="' + searchHref('') + '">VIEW ALL ITEMS →</a>';
    var right = '<h3 class="ss-col__title">Featured Products</h3><div class="ss-grid ss-grid--loading"><div class="ss-empty">Loading…</div></div>';
    panel.innerHTML = '<div class="ss-columns"><div class="ss-col ss-col--left">' + left +
      '</div><div class="ss-col ss-col--right">' + right + '</div></div>';

    var isMobile = window.innerWidth <= 999;
    var handles = isMobile ? [
      'kashaka-cas-cas-shakers',
      'peruvian-bird-water-whistle-6cm'
    ] : [
      'kashaka-cas-cas-shakers',
      'peruvian-bird-water-whistle-6cm',
      'siku-pan-pipes',
      'gobijeu-indian-stringed-instrument',
      '17-note-kalimba-bundle',
      'croaking-frog-guiro'
    ];
    if (!handles.length) return;

    Promise.all(handles.map(function(handle) {
      return fetch('/products/' + handle + '.js')
        .then(function(r) { return r.json(); })
        .catch(function() { return null; });
    })).then(function(results) {
      var products = results.filter(Boolean).map(function(p) {
        var variant = p.variants && p.variants[0];
        var rawPrice = variant ? variant.price : 0;
        var rawCompare = variant ? variant.compare_at_price : null;
        return {
          title: p.title,
          handle: p.handle,
          url: '/products/' + p.handle,
          image: p.featured_image || (p.images && p.images[0] && p.images[0].src) || '',
          price: rawPrice ? (rawPrice / 100).toFixed(2) : '',
          compare_at_price: rawCompare ? (rawCompare / 100).toFixed(2) : '',
          available: p.variants ? p.variants.some(function(v) { return v.available; }) : false,
          description: p.body_html || '',
          variant_id: variant ? variant.id : ''
        };
      });
      var rightCol = panel.querySelector('.ss-col--right');
      if (rightCol) {
        rightCol.innerHTML = '<h3 class="ss-col__title">Featured Products</h3><div class="ss-grid">' +
          (products.length ? products.map(productCard).join('') : '<div class="ss-empty">No products found</div>') +
          '</div>';
      }
    });
  }

  function renderZero(panel, query, popular) {
    panel.innerHTML = '<div class="ss-columns"><div class="ss-col ss-col--left">' +
      '<div class="ss-col__section"><h3 class="ss-col__title">Did you mean…</h3><ul class="ss-list">' +
      (popular || []).map(function (t) {
        return suggestionItem(t, query, searchHref(t));
      }).join('') + '</ul></div></div><div class="ss-col ss-col--right"><h3 class="ss-col__title">Products</h3><div class="ss-empty">No exact matches for "' + query + '"</div></div></div>';
  }

  window.SmartSearchRendering = { render: render, renderZero: renderZero, renderEmpty: renderEmpty, formatMoney: formatMoney };
})();
// search.js
// Fetches predictive results, applies synonyms + scoring, orchestrates render.
(function () {
  function config() {
    return window.SmartSearchConfig || window.SmartSearchDefaults || {};
  }

  var DEBOUNCE_MS = 200;
  var MIN_CHARS = 1;

  // Build a suggest URL for specific resource types. The predictive API caps
  // total results across ALL types, so we call it separately for products vs.
  // pages/articles to guarantee up to 10 products come back.
  function suggestUrl(query, type, limit) {
    return '/search/suggest.json?q=' + encodeURIComponent(query) +
      '&resources[type]=' + type +
      '&resources[limit]=' + limit +
      '&resources[options][unavailable_products]=last';
  }

  // Extracts an image URL from the several shapes the predictive API can return:
  //   p.featured_image.url | p.featured_image (string) | p.image (string or object)
  //   | p.images[0] (string or object) | first variant image.
  function extractImage(p) {
    function fromField(v) {
      if (!v) return '';
      if (typeof v === 'string') return v;
      if (typeof v === 'object') return v.url || v.src || '';
      return '';
    }
    var img = fromField(p.featured_image) || fromField(p.image);
    if (!img && Array.isArray(p.images) && p.images.length) img = fromField(p.images[0]);
    if (!img && p.variants && p.variants[0]) img = fromField(p.variants[0].image) || fromField(p.variants[0].featured_image);
    return img || '';
  }

  // Prices from predictive search may be a formatted string ("£30.00"), a
  // decimal string ("30.00"), or a number. Pass through as-is; the money
  // formatter in rendering.js decides how to display it.
  function extractPrice(v) {
    if (v === null || v === undefined) return '';
    return v;
  }
function normalise(json) {
  var r = (json && json.resources && json.resources.results) || {};
  var products = (r.products || []).map(function (p) {
    return {
      title: p.title,
      handle: p.handle,
      url: p.url,
      image: extractImage(p),
      price: extractPrice(p.price),
      compare_at_price: extractPrice(p.compare_at_price),
      description: p.body || p.description || '',
      available: p.available,
      product_type: p.type,
      tags: p.tags,
      variant_id: '',
      product_handle: p.handle || ''
    };
  });
  var pages = (r.pages || []).map(function (pg) { return { title: pg.title, url: pg.url, kind: 'page' }; });
  var articles = (r.articles || []).map(function (a) { return { title: a.title, url: a.url, kind: 'article' }; });
  var queries = (r.queries || []).map(function (q) { return { label: q.text, url: q.url }; });
  return { products: products, pages: pages.concat(articles), suggestions: queries };
}

  function doSearch(query, panel) {
    var q = (query || '').trim();
q = SmartSearchFuzzy.correct(q);
    if (q.length < MIN_CHARS) { closePanel(panel); return; }

    var terms = window.SmartSearchSynonyms.expandQuery(q);
    var cacheKey = terms.join('|');
    if (window.SmartSearchCache.has(cacheKey)) {
      finish(q, panel, window.SmartSearchCache.get(cacheKey));
      return;
    }

    var stopWords = ['how', 'to', 'the', 'a', 'an', 'and', 'or', 'for', 'of', 'in', 'is', 'it', 'do', 'i', 'my', 'what', 'best'];

    var fetches = [];
    terms.forEach(function (t) {
      fetches.push({
        term: t,
        kind: 'products',
        promise: fetch(suggestUrl(t, 'product', 10)).then(function (res) { return res.json(); }).catch(function () { return {}; })
      });
      fetches.push({
        term: t,
        kind: 'pages',
        promise: fetch(suggestUrl(t, 'page,article', 10)).then(function (res) { return res.json(); }).catch(function () { return {}; })
      });
      var keywords = t.split(/\s+/).filter(function(w) {
        return w.length > 2 && stopWords.indexOf(w.toLowerCase()) === -1;
      });
      keywords.forEach(function(kw) {
        if (kw !== t) {
          fetches.push({
            term: kw,
            kind: 'pages',
            promise: fetch(suggestUrl(kw, 'page,article', 10)).then(function (res) { return res.json(); }).catch(function () { return {}; })
          });
          fetches.push({
            term: kw,
            kind: 'products',
            promise: fetch(suggestUrl(kw, 'product', 10)).then(function (res) { return res.json(); }).catch(function () { return {}; })
          });
        }
      });
    });

    Promise.all(fetches.map(function (f) { return f.promise; })).then(function (results) {
      var merged = { products: [], pages: [], suggestions: [] };
      var seenProducts = {};
      var seenPages = {};
      results.forEach(function (json, i) {
        var meta = fetches[i];
        var n = normalise(json);
        var isSynonymTerm = meta.term !== terms[0];
        n.products.forEach(function (p) {
          if (!seenProducts[p.handle]) {
            seenProducts[p.handle] = 1;
            p.matchedViaSynonym = isSynonymTerm;
            merged.products.push(p);
          }
        });
        n.pages.forEach(function (pg) {
          if (!seenPages[pg.url]) {
            seenPages[pg.url] = 1;
            merged.pages.push(pg);
          }
        });
        merged.suggestions = merged.suggestions.concat(n.suggestions);
      });
      window.SmartSearchCache.set(cacheKey, merged);
      finish(q, panel, merged);
    });
  }

  
   function finish(query, panel, data) {
    window.SmartSearchAnalytics.recordSearch(query, data.products.length);
    var maxProducts = window.innerWidth <= 999 ? 5 : (config().appearance || {}).maxProducts || 6;

var ranked = window.SmartSearchScoring.rankProducts(query, data.products).slice(0, maxProducts);

    if (!ranked.length) {
      if (query.indexOf(' ') === -1) {
        fuzzyFallback(query, panel, data, query.length - 1);
      } else {
        window.SmartSearchRendering.renderZero(panel, query, (config().featured || []));
        openPanel(panel);
      }
    } else {
      window.SmartSearchRendering.render(panel, query, {
        products: ranked,
        pages: window.innerWidth <= 999 ? data.pages.slice(0, 3) : data.pages,
        suggestions: data.suggestions,
        totalProducts: ranked.length
      });
      openPanel(panel);
    }
  }

  function fuzzyFallback(originalQuery, panel, data, trimTo) {
    if (trimTo < 2) {
      window.SmartSearchRendering.renderZero(panel, originalQuery, (config().featured || []));
      openPanel(panel);
      return;
    }
    var fallback = originalQuery.slice(0, trimTo);
    fetch('/search/suggest.json?q=' + encodeURIComponent(fallback) +
      '&resources[type]=product&resources[limit]=10&resources[options][unavailable_products]=last')
      .then(function(r) { return r.json(); })
      .then(function(json) {
        var n = normalise(json);
        var fallbackRanked = window.SmartSearchScoring.rankProducts(fallback, n.products);
        if (fallbackRanked.length) {
          window.SmartSearchRendering.render(panel, originalQuery, {
            products: fallbackRanked,
            pages: window.innerWidth <= 999 ? data.pages.slice(0, 3) : data.pages,
            suggestions: data.suggestions,
            totalProducts: fallbackRanked.length
          });
          openPanel(panel);
        } else {
          fuzzyFallback(originalQuery, panel, data, trimTo - 1);
        }
      })
      .catch(function() {
        window.SmartSearchRendering.renderZero(panel, originalQuery, (config().featured || []));
        openPanel(panel);
      });
  }

   function openPanel(panel, input) {
    panel.hidden = false;
    panel.classList.add('is-open');
    if (input) input.setAttribute('aria-expanded', 'true');
  }

  function closePanel(panel, input) {
    panel.classList.remove('is-open');
    panel.hidden = true;
    if (input) input.setAttribute('aria-expanded', 'false');
  }

  window.SmartSearch = { doSearch: doSearch, openPanel: openPanel, closePanel: closePanel, DEBOUNCE_MS: DEBOUNCE_MS, MIN_CHARS: MIN_CHARS };
})();


// analytics.js
// Placeholder analytics hooks. In the current backend-free build these are
// no-ops. A future backend can implement them to capture searches, clicks and
// purchases for CTR / conversion learning. Shopify's built-in Analytics already
// reports top storefront search terms in the meantime.
(function () {
  function recordSearch(query, resultCount) { /* hook: forward to backend */ }
  function recordClick(query, productHandle) { /* hook: forward to backend */ }
  function recordPurchase(query, productHandle, revenue) { /* hook: forward to backend */ }

  window.SmartSearchAnalytics = {
    recordSearch: recordSearch,
    recordClick: recordClick,
    recordPurchase: recordPurchase
  };
})();


// analytics.js
(function () {
  function recordSearch(query, resultCount) { }
  function recordClick(query, productHandle) { }
  function recordPurchase(query, productHandle, revenue) { }
  window.SmartSearchAnalytics = { recordSearch: recordSearch, recordClick: recordClick, recordPurchase: recordPurchase };
})();

// ui.js
(function () {
  function config() { return window.SmartSearchConfig || window.SmartSearchDefaults || {}; }

  function applyTheme() {
    var a = config().appearance || {};
    var root = document.getElementById('smart-search');
    if (!root) return;
    root.style.setProperty('--ss-bg', a.background || '#FFFFFF');
    root.style.setProperty('--ss-text', a.text || '#1A1A1A');
    root.style.setProperty('--ss-button', a.button || '#000000');
    root.style.setProperty('--ss-accent', a.accent || '#000000');
    root.style.setProperty('--ss-radius', (a.borderRadius || 12) + 'px');
    root.style.setProperty('--ss-font', (a.fontSize || 15) + 'px');
    root.style.setProperty('--ss-atc-bg', a.atcBackground || '#1A1A1A');
    root.style.setProperty('--ss-atc-text', a.atcText || '#FFFFFF');
    root.style.setProperty('--ss-bar-border', a.barBorder || '#dcdcdc');
    root.style.setProperty('--ss-suggestion-icon', a.suggestionIcon || '#b0b0b0');
  }

  function initInstance(inputId, panelId, submitId, rootId) {
    var input = document.getElementById(inputId);
    var panel = document.getElementById(panelId);
    if (!input || !panel) return;

    var timer = null;
    input.addEventListener('input', function () {
  if (timer) clearTimeout(timer);
  var val = input.value;
  if (val.trim()) {
    panel.removeAttribute('hidden');
    timer = setTimeout(function () { window.SmartSearch.doSearch(val, panel); }, window.SmartSearch.DEBOUNCE_MS);
  } else {
    window.SmartSearchRendering.renderEmpty(panel, config().featured || []);
    window.SmartSearch.openPanel(panel, input);
  }
});

input.addEventListener('focus', function () {
  if (!input.value) {
    window.SmartSearchRendering.renderEmpty(panel, config().featured || []);
    window.SmartSearch.openPanel(panel, input);
  }
});

    var submit = document.getElementById(submitId);
    if (submit) {
      submit.addEventListener('click', function () {
        var term = (input.value || '').trim();
        if (!term) { input.focus(); return; }
        var base = (window.SmartSearchShop && window.SmartSearchShop.searchUrl) || '/search';
        window.location.href = base + '?q=' + encodeURIComponent(term);
      });
    }

    document.addEventListener('click', function (e) {
      var root = document.getElementById(rootId);
      if (root && !root.contains(e.target)) {
        if (panel && panel.classList.contains('is-open')) {
          window.SmartSearch.closePanel(panel, input);
        }
      }
    });

    input.addEventListener('keydown', function (e) {
      var items = panel.querySelectorAll('[role="option"]');
      var current = panel.querySelector('.is-active');
      var idx = -1;
      for (var i = 0; i < items.length; i++) { if (items[i] === current) idx = i; }
      if (e.key === 'Escape') { window.SmartSearch.closePanel(panel, input); input.blur(); }
      else if (e.key === 'ArrowDown') { e.preventDefault(); move(items, idx, 1); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); move(items, idx, -1); }
      else if (e.key === 'Enter') {
        if (current) {
          var link = current.querySelector('a');
          if (link) { e.preventDefault(); window.location.href = link.href; }
        } else {
          var term = (input.value || '').trim();
          if (term) {
            e.preventDefault();
            var base = (window.SmartSearchShop && window.SmartSearchShop.searchUrl) || '/search';
            window.location.href = base + '?q=' + encodeURIComponent(term);
          }
        }
      }
    });

    function move(items, idx, dir) {
      if (!items.length) return;
      if (idx >= 0) items[idx].classList.remove('is-active');
      var next = (idx + dir + items.length) % items.length;
      items[next].classList.add('is-active');
      items[next].scrollIntoView({ block: 'nearest' });
    }
  }

     // AJAX add to cart — document-level delegation (shared by desktop + mobile)
  document.addEventListener('click', function (e) {
    if (!e.target) return;
    var btn = e.target.closest ? e.target.closest('.ss-card__atc') : null;
    if (!btn || btn.disabled) return;
    e.preventDefault();
    var variant = btn.getAttribute('data-variant');
    var handle = btn.getAttribute('data-handle');
    if (!variant && !handle) return;
    var original = btn.textContent;
    btn.textContent = 'Adding…';

    function doAdd(vid) {
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(vid), quantity: 1 }] })
      }).then(function(res) { return res.json(); }).then(function(data) {
        if (data.status) {
          btn.textContent = 'Error';
          setTimeout(function() { btn.textContent = original; }, 1500);
        } else {
          btn.textContent = 'Added ✓';
          setTimeout(function() { btn.textContent = original; }, 1500);
          fetch('/cart.js')
            .then(function(r) { return r.json(); })
            .then(function(cart) {
              document.querySelectorAll('.header__cart-count').forEach(function(el) {
                el.textContent = cart.item_count;
              });
              fetch('/cart?section_id=mini-cart')
                .then(function(r) { return r.text(); })
                .then(function(html) {
                  var parser = new DOMParser();
                  var doc = parser.parseFromString(html, 'text/html');
                  var newCart = doc.getElementById('mini-cart');
                  var oldCart = document.getElementById('mini-cart');
                  if (newCart && oldCart) {
                    oldCart.innerHTML = newCart.innerHTML;
                    oldCart.setAttribute('data-item-count', cart.item_count);
                  }
                })
                .finally(function() {
                  var trigger = document.querySelector('[data-action="toggle-mini-cart"]');
                  if (trigger) trigger.click();
                });
            });
        }
      }).catch(function() {
        btn.textContent = 'Try again';
        setTimeout(function() { btn.textContent = original; }, 1500);
      });
    }

    if (variant) {
      doAdd(variant);
    } else {
      fetch('/products/' + handle + '.js')
        .then(function(r) { return r.json(); })
        .then(function(prod) {
          var vid = prod.variants && prod.variants[0] && prod.variants[0].id;
          if (vid) doAdd(vid);
          else { btn.textContent = 'Error'; setTimeout(function() { btn.textContent = original; }, 1500); }
        }).catch(function() {
          btn.textContent = 'Error';
          setTimeout(function() { btn.textContent = original; }, 1500);
        });
    }
  });

  function init() {
    applyTheme();
     // Desktop instance
    initInstance('smart-search-input', 'smart-search-panel', 'smart-search-submit', 'smart-search');

     // Mobile full-screen overlay
    var overlay = document.getElementById('smart-search-mobile-overlay');
    var mobileInput = document.getElementById('smart-search-input-mobile');
    var mobilePanel = document.getElementById('smart-search-panel-mobile');
    var mobileClose = document.getElementById('smart-search-close-mobile');
    var trigger = document.getElementById('mobile-search-trigger');

    function openMobileSearch() {
      if (!overlay) return;
      overlay.removeAttribute('hidden');
      overlay.classList.add('is-open');
      document.body.classList.add('ss-search-open');
      setTimeout(function() {
  if (mobileInput) {
    mobileInput.focus();
    mobileInput.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
}, 300);
      if (mobileInput && !mobileInput.value) {
        var cfg = window.SmartSearchConfig || window.SmartSearchDefaults || {};
window.SmartSearchRendering.renderEmpty(mobilePanel, cfg.featured || []);

        window.SmartSearch.openPanel(mobilePanel, mobileInput);
      }
    }

    function closeMobileSearch() {
      if (!overlay) return;
      overlay.classList.remove('is-open');
      overlay.setAttribute('hidden', '');
      document.body.classList.remove('ss-search-open');
      if (mobilePanel) window.SmartSearch.closePanel(mobilePanel, mobileInput);
      if (mobileInput) { mobileInput.blur(); mobileInput.value = ''; }
    }

    if (trigger) trigger.addEventListener('click', openMobileSearch);
    if (mobileClose) mobileClose.addEventListener('click', closeMobileSearch);

    // Wire up typing
    if (mobileInput) {
      var mobileTimer = null;
      mobileInput.addEventListener('input', function() {
  if (mobileTimer) clearTimeout(mobileTimer);
  var val = mobileInput.value;
  if (val.trim()) {
    // hide default suggestions immediately, show live results
    mobilePanel.removeAttribute('hidden');
    mobileTimer = setTimeout(function() {
      window.SmartSearch.doSearch(val, mobilePanel);
    }, window.SmartSearch.DEBOUNCE_MS);
  } else {
    // back to empty state — show popular searches
    var cfg = window.SmartSearchConfig || window.SmartSearchDefaults || {};
window.SmartSearchRendering.renderEmpty(mobilePanel, cfg.featured || []);

    window.SmartSearch.openPanel(mobilePanel, mobileInput);
  }
});

      mobileInput.addEventListener('keydown', function(e) {
        if (e.key === 'Enter') {
          var term = mobileInput.value.trim();
          if (term) {
            e.preventDefault();
            var base = (window.SmartSearchShop && window.SmartSearchShop.searchUrl) || '/search';
            window.location.href = base + '?q=' + encodeURIComponent(term);
          }
        }
        if (e.key === 'Escape') closeMobileSearch();
      });
    }

  } // closes init()

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();